import api from "../api/api";

/**
 * Convert image path to absolute URL
 * Handles:
 * - absolute: http/https
 * - /storage/...
 * - storage/...
 * - hero/a.jpg | categories/a.jpg → /storage/...
 */
const toAbsoluteUrl = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;

  let path = url.startsWith("/") ? url : `/${url}`;

  if (!path.startsWith("/storage/")) {
    path = `/storage${path}`;
  }

  const base = (api.defaults.baseURL || "").replace(/\/api\/?$/, "");
  return `${base}${path}`;
};

/**
 * Normalize flat category responses
 * Supports:
 *  - response.data.data (array)
 *  - response.data.data.data (pagination)
 *  - response.data (array)
 */
export const normalizeCategoriesResponse = (response) => {
  let categoriesData = [];

  if (response?.data) {
    if (response.data.data) {
      if (Array.isArray(response.data.data)) {
        categoriesData = response.data.data;
      } else if (response.data.data.data) {
        categoriesData = response.data.data.data;
      }
    } else if (Array.isArray(response.data)) {
      categoriesData = response.data;
    }
  }

  return categoriesData;
};

/**
 * Normalize category TREE response
 * (parent + children)
 */
const normalizeCategoryTree = (data = []) => {
  return data.map((parent) => ({
    ...parent,
    parent_id: Number(parent.parent_id || 0),
    image: toAbsoluteUrl(parent.image_url || parent.image),

    children: (parent.children || []).map((child) => ({
      ...child,
      parent_id: Number(child.parent_id || 0),
      image: toAbsoluteUrl(child.image_url || child.image),
    })),
  }));
};

// ----------------------------------
// API Calls (Frontend)
// ----------------------------------
export const CategoriesServices = {
  /**
   * Admin / flat list (pagination supported)
   */
  async listAll() {
    const response = await api.get("/get-categories");

    const categories = normalizeCategoriesResponse(response);

    return categories.map((cat) => ({
      ...cat,
      parent_id: Number(cat.parent_id || 0),
      image: toAbsoluteUrl(cat.image_url || cat.image),
    }));
  },

  /**
   * 🔥 Frontend Header Category Tree
   * Returns:
   * [
   *   { id, name, parent_id: 0, children: [...] }
   * ]
   */
  async getCategoryTree() {
    const response = await api.get("/get-category-tree");

    const tree = response?.data?.data || [];
    return normalizeCategoryTree(tree);
  },
};
